import { useEffect, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { useLocation } from 'react-router-dom'
import { parseViewerRequest } from './viewerRequest'
import { getViewerLinks } from './viewerStorage'

export default function PdfViewer() {
  const { authState } = useOktaAuth()
  const { search } = useLocation()
  const [links, setLinks] = useState(null)
  const [error, setError] = useState(null)
  const [revision, setRevision] = useState(0)
  const token = authState?.idToken?.idToken

  useEffect(() => {
    const controller = new AbortController()
    setLinks(null)
    setError(null)
    async function load() {
      const request = parseViewerRequest(search)
      if (!token) throw new Error('Your session has expired. Please reopen this report link.')
      const result = await getViewerLinks(request, authState.idToken, controller.signal)
      if (!controller.signal.aborted) setLinks(result)
    }
    load().catch(err => {
      if (!controller.signal.aborted) setError(err.message)
    })
    return () => controller.abort()
  }, [search, token, revision, authState.idToken])

  return <main className='min-h-screen bg-gray-50 p-4 flex flex-col gap-4'>
    <header className='flex flex-wrap items-center gap-4'>
      <h1 className='text-xl font-semibold'>PDF report viewer</h1>
      {links && <>
        <a className='text-purple-700 underline' href={links.viewUrl} target='_blank' rel='noopener noreferrer'>Open PDF in new tab</a>
        <a className='text-purple-700 underline' href={links.downloadUrl} referrerPolicy='no-referrer'>Download PDF</a>
      </>}
      <button className='text-purple-700 underline' onClick={() => setRevision(value => value + 1)}>Reload report</button>
    </header>
    {error ? <p role='alert' className='text-red-700'>{error}</p> : !links ?
      <p role='status'>Checking report access…</p> : <>
        <p className='text-sm text-gray-600'>If your browser cannot display the PDF, use Open PDF in new tab or Download PDF. Reload the report if a temporary link expires.</p>
        <iframe title='PDF report' src={links.viewUrl} referrerPolicy='no-referrer'
          className='w-full flex-1 border rounded bg-white' style={{ minHeight: '80vh' }} />
      </>}
  </main>
}
